export default __webpack_public_path__ + "static/media/mexicanfood.dbcf52f9.jpeg";